const getDate = (timestamp, days = 0) => {
    const date = new Date(timestamp);
    date.setHours(date.getHours() + 9);
    date.setDate(date.getDate() + days);
    return date.toISOString().split('T')[0];
}

const getDateTime = (timestamp, days = 0) => {
    const date = new Date(timestamp);
    date.setHours(date.getHours() + 9);
    date.setDate(date.getDate() + days);
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

const getDayDiff = (timestamp, days = 0) => {
    if (!days) return 0;
    const date = new Date(timestamp);
    date.setDate(date.getDate() + days);
    const endDate = new Date();
    const startDateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const diffTime = startDateOnly - endDateOnly;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};

export { getDate, getDateTime, getDayDiff };